import React from 'react';
import Layout from '../../components/Layout';
import { useNavigate } from 'react-router-dom';
const Employer: React.FC = () => {
  const navigate = useNavigate();
  return <Layout title={<h1 className="text-2xl font-semibold text-gray-800" data-id="element-2428">
          Employer Dashboard
        </h1>} persona="Company/Partner" data-id="element-2427">
      <div className="max-w-5xl mx-auto bg-white rounded-lg border border-gray-200 shadow-sm p-8" data-id="element-2429">
        <h2 className="text-xl font-medium text-gray-900 mb-6" data-id="element-2430">
          Welcome to the Employer Portal
        </h2>
        <p className="text-gray-600 mb-8" data-id="element-2431">
          This is a placeholder for the Employer Dashboard. The full
          implementation will include scholarship management and applicant
          tracking.
        </p>
        <div className="flex space-x-4" data-id="element-2432">
          <button onClick={() => navigate('/employer/create-scholarship')} className="px-4 py-2 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors" data-id="element-2433">
            Create Scholarship
          </button>
          <button onClick={() => navigate('/employer/applications')} className="px-4 py-2 bg-secondary-500 text-white rounded-md text-sm font-medium hover:bg-secondary-600 transition-colors" data-id="element-2434">
            View Applications
          </button>
        </div>
      </div>
    </Layout>;
};
export default Employer;